import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { cn } from '@/lib/utils';
import { MenuSectionConfig } from './menuConfig';

interface MobileAccordionMenuProps {
  config: MenuSectionConfig;
  onLinkClick: () => void;
}

export const MobileAccordionMenu: React.FC<MobileAccordionMenuProps> = ({
  config,
  onLinkClick
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Collapsible 
      open={isOpen} 
      onOpenChange={setIsOpen}
      className="border-b border-border"
    >
      <CollapsibleTrigger className="flex items-center justify-between w-full text-left py-3 px-2 text-foreground hover:text-accent transition-colors">
        <span className="flex items-center gap-2">
          <span className="font-medium">{config.label}</span>
        </span>
        <ChevronDown className={cn(
          "h-4 w-4 transition-transform duration-200",
          isOpen && "rotate-180"
        )} />
      </CollapsibleTrigger>
      
      <CollapsibleContent className="pb-3">
        <div className="space-y-1 pl-2">
          {config.items.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors"
                onClick={onLinkClick}
              >
              <div 
                className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${item.accentColor}15` }}
              >
                <item.icon 
                  className="w-4 h-4" 
                  style={{ color: item.accentColor }}
                  strokeWidth={1.5}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground leading-tight">
                  {item.title}
                </p>
              </div>
            </Link>
          ))}

          {/* Footer CTA link */}
          {config.footerCta && (
            <div className="border-t border-border/50 mt-2 pt-2">
              <Link
                to={config.footerCta.path}
                className="block py-2 px-3 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
                onClick={onLinkClick}
              >
                {config.footerCta.label} →
              </Link>
            </div>
          )}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default MobileAccordionMenu;
